import {
  TABLE_SORT_DIRECTIONS,
  SORT_DIRECTIONS as SORT_DIRECTIONS_ENUM,
} from 'constants/sortDirectionsEnum';
import { ASCENDING, DESCENDING, SortDirections } from 'constants/sortDirections';

/**
 * getSortDirection
 * helper utility that returns the opposite direction (asc/desc) than the one that's provided
 */
export const getSortDirection = (sortDirection: TABLE_SORT_DIRECTIONS): TABLE_SORT_DIRECTIONS =>
  sortDirection === TABLE_SORT_DIRECTIONS.ASCENDING
    ? TABLE_SORT_DIRECTIONS.DESCENDING
    : TABLE_SORT_DIRECTIONS.ASCENDING;

/**
 *
 * @param sortDirection
 * @returns SortDirections or SORT_DIRECTIONS_ENUM
 *
 * getNewSortDirection is a backwards-compatible utility that returns the opposite direction (asc/desc) than the one that's provided
 */
export const getNewSortDirection = (sortDirection: SORT_DIRECTIONS_ENUM | SortDirections) => {
  switch (sortDirection) {
    case SORT_DIRECTIONS_ENUM.ASCENDING:
      return SORT_DIRECTIONS_ENUM.DESCENDING;
    case SORT_DIRECTIONS_ENUM.DESCENDING:
      return SORT_DIRECTIONS_ENUM.ASCENDING;
    case ASCENDING:
      return DESCENDING;
    case DESCENDING:
      return ASCENDING;
    default:
      return ASCENDING;
  }
};
